import { useState } from 'react';
import styled, { css } from 'styled-components';
import {
  flexBoxCenter,
  flexDirectionColumn,
  justifyContentFlexEnd,
  layerB,
  messageBoxBackground,
} from 'shared/styles/commonStyles';

import MessageBoxButton from './MessageBoxButton';

const InputTempMessage = ({
  onClose,
  title,
  subtitle,
  messages,
  isMobile,
  unitLabel,
  onSubmitTemp,
  minTemp,
  maxTemp,
}) => {
  const [tempInput, setTempInput] = useState('');
  const [error, setError] = useState('');
  const canSubmitTemp = typeof onSubmitTemp === 'function';

  const handleApply = (e) => {
    e.preventDefault();
    const temp = Number(tempInput);

    if (!tempInput || !Number.isFinite(temp)) {
      setError('please input temperature');
      return;
    }

    if (minTemp != null && temp < minTemp) {
      setError(`minimum temperature is ${minTemp}${unitLabel ? ` ${unitLabel}` : ''}`);
      return;
    }

    if (maxTemp != null && temp > maxTemp) {
      setError(`maximum temperature is ${maxTemp}${unitLabel ? ` ${unitLabel}` : ''}`);
      return;
    }

    setError('');
    onSubmitTemp(temp);
  };

  return (
    <Wrapper isMobile={isMobile}>
      <MessageInner isMobile={isMobile}>
        <HeaderWrapper>
          <TitleWrapper>
            <Title>{title}</Title>
            <Logo src='/images/messagebox-logo.svg' />
          </TitleWrapper>
          <SubTitleWrapper>
            <SubTitle>{subtitle}</SubTitle>
          </SubTitleWrapper>
        </HeaderWrapper>
        <MessageWrapper>
          {messages.map((message, index) => (
            <Message key={index} idx={index}>
              {message}
            </Message>
          ))}
        </MessageWrapper>
        {canSubmitTemp && (
          <TempInputWrapper>
            <TempInput
              type='number'
              value={tempInput}
              onChange={(e) => {
                setTempInput(e.target.value);
                if (error) setError('');
              }}
              placeholder={`input temp${unitLabel ? ` ${unitLabel}` : ''}`}
              autoFocus
            />
            {error && <ErrorText>{error}</ErrorText>}
          </TempInputWrapper>
        )}
        <ButtonWrapper>
          {canSubmitTemp && <MessageBoxButton name='apply' buttonHandler={handleApply} />}
          <MessageBoxButton name={canSubmitTemp ? 'cancel' : 'ok'} buttonHandler={onClose} />
        </ButtonWrapper>
      </MessageInner>
    </Wrapper>
  );
};

export default InputTempMessage;

const Wrapper = styled.div`
  min-width: 402px;
  min-height: 190px;
  border-radius: 14px;
  ${messageBoxBackground}
  ${flexBoxCenter};
  padding: 10px;

  ${({ isMobile }) =>
    isMobile &&
    css`
      min-width: 376px;
    `}
`;
const MessageInner = styled.div`
  min-width: 384px;
  min-height: 172px;
  border-radius: 9px;

  ${layerB}
  ${flexDirectionColumn}
  padding: 10px;

  ${({ isMobile }) =>
    isMobile &&
    css`
      min-width: 356px;
    `}
`;

const HeaderWrapper = styled.div`
  width: 100%;
  height: 15%;
  margin-bottom: 12px;
`;

const TitleWrapper = styled.div`
  width: 100%;
  height: 10%;

  border-bottom: 1px solid #fff;
  display: flex;
  justify-content: space-between;
`;
const Title = styled.span`
  font-size: 14px;
`;

const Logo = styled.img`
  height: 80%;
`;

const SubTitleWrapper = styled.div`
  width: 100%;
  ${justifyContentFlexEnd};
`;

const SubTitle = styled.span`
  width: fit-content;
  margin-top: 2px;
  font-size: 12px;
`;

const MessageWrapper = styled.div`
  width: 100%;
  min-height: 60px;
  margin-bottom: 12px;
  ${flexBoxCenter};
  flex-direction: column;
`;
const Message = styled.p`
  font-size: 12px;
  text-align: center;

  ${({ idx }) =>
    idx === 0 &&
    css`
      margin-bottom: 10px;
    `}
`;

const ButtonWrapper = styled.div`
  height: 20%;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const TempInputWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
`;

const TempInput = styled.input`
  width: 150px;
  height: 28px;
  border-radius: 14px;
  border: 1px solid rgba(59, 130, 246, 0.55);
  background: rgba(15, 23, 42, 0.65);
  color: #ffffff;
  font-size: 12px;
  text-align: center;
  outline: none;

  &::placeholder {
    color: rgba(255, 255, 255, 0.55);
  }

  &:focus {
    border-color: #60a5fa;
  }
`;

const ErrorText = styled.span`
  color: #ee4b56;
  font-size: 11px;
  text-align: center;
`;
